import { Col, DatePicker, Input, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
// import SelectSearch from '../../../../component/input/SelectSearch';
import { LoadingOption, dropdownCustom, selectOption } from '../../../../component/select/SelectOption';
import { GROLOG_URL } from '../../../../constant/apiConstant';
import axios from 'axios';
import { useSelector } from 'react-redux';
import SelectSearch from '../../../../component/input/SelectSearch';


const UserProfile = ({
  listCountry, Province, District, SubDistrict,
  UrbanVillage, PostalCode, 
  _onChange, _onChangeSelect, form, style,
  onChangeCountry,
  onChangeDistrict,
  onChangePostalCode,
  onChangeProvince,
  onChangeSubdistrict,
  onChangeUrbanvillage,
  onScrollCountry,
  onScrollDistrict,
  onScrollPostalCode,
  onScrollProvince,
  onScrollUrbanvillage,
  onScrollSubdistrict,
  loading,
  searchValue,
  error
}) => {
console.log("dapet",error);
  // const [Country, setListCountry] = useState([]);
  // const [listProvince, setListProvince] = useState([]);
  // const [listDistrict, setListDistrict] = useState([]);
  // const [listSubDistrict, setListSubDistrict] = useState([]);
  // const [listUrbanVillage, setListUrbanVillage] = useState([]);
  // const [listPostalCode, setListPostalCode] = useState([]);
  // const [listTitle, setListTitle] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [searchValue, setSearchValue] = useState("");
  // const [pageCountry, setPageCountry] = useState(1);
  // const [limitCountry, setLimitCountry] = useState(10);
  // const [filter, setFilter] = useState("");
  // const [pageProvince, setPageProvince] = useState(1);
  // const [limitProvince, setLimitProvince] = useState(10);
  // const [filterProvince, setFilterProvince] = useState("");
  // const [pageDistrict, setPageDistrict] = useState(1);
  // const [limitDistrict, setLimitDistrict] = useState(10);
  // const [filterDistrict, setFilterDistrict] = useState("");
  // const [pageSubdistrict, setPageSubdistrict] = useState(1);
  // const [limitSubdistrict, setLimitSubdistrict] = useState(10);
  // const [filterSubdistrict, setFilterSubdistrict] = useState("");
  // const [pageUrbanvillage, setPageUrbanvillage] = useState(1);
  // const [limitUrbanvillage, setLimitUrbanvillage] = useState(10);
  // const [filterUrbanvillage, setFilterUrbanvillage] = useState("");
  // const [pagePostalCode, setPagePostalCode] = useState(1);
  // const [limitPostalCode, setLimitPostalCode] = useState(10);
  // const [filterPostalCode, setFilterPostalCode] = useState("");
  // const { token } = useSelector((state) => state.auth);

  // const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
  //   const url = GROLOG_URL + endpoint;
  //   const method = "GET";
  //   const headers = { Authorization: tkn };
  //   const request = { url, method, headers, params };
  //   return axios(request);
  // };
  // useEffect(() => {
  //   getListCountry(1, 100);
  //   getListProvince(form.country_id, 1, 100, "");
  //     getListDistrict(
  //       form.country_id,
  //       form.province_id,
  //       1,
  //       100,
  //       "");
  //     getListSubDistrict(
  //       form.country_id,
  //       form.district_id,
  //       1,
  //       500,
  //       ""
  //     );
  //     getListUrbanVillage(
  //       form.country_id,
  //       form.sub_district_id,
  //       1,
  //       100,
  //       "");
  //     getListPostalCode(
  //       form.urban_village_id,
  //       1,
  //       100,
  //       "");
  //   },[form])

  // const getListCountry = async (page, limit, filter) => {
  //   const currentCountry = [...listCountry];
  //   let countrys = await doGets(
  //     `/country?page=${page}&limit=${limit}${filter && `&filter=name lk ${filter}`
  //     }`,
  //     token
  //   );

  //   let option = [];
  //   let list = countrys?.data?.payload?.data;

  //   if (list !== null && list.length !== undefined) {
  //     for (let i = 0; i < list.length; i++) {
  //       const element = list[i];
  //       let data = {
  //         id: element.id,
  //         value: element.name,
  //       };
  //       option.push(data);
  //     }
  //     setListCountry(selectOption(currentCountry, option, "value"));
  //     setLoading(false);
  //     // this.setState({
  //     //   listUser: selectOption(currentUser, option, "value"),
  //     //   initiateUser: initiate,
  //     //   loading: false,
  //     // });
  //   } else {
  //     setLoading(false);
  //     // this.setState({ loading: false, lastPage: true });
  //   }
  // };
  
  // const isZero = []
  // const getListProvince = async (id, page, limit, filter, isChange) => {
  //   const currentProvince = [...listProvince];
  //   let provinces = await doGets(
  //     `/province?page=${page}&limit=${limit}&filter=country_id eq ${id}${filter ? `, name lk ${filter}` : ""
  //     }`,
  //     token
  //   );
  //   let option = [];
  //   let list = provinces?.data?.payload?.data;
  //   if (list !== null && list.length !== undefined) {
  //     for (let i = 0; i < list.length; i++) {
  //       const element = list[i];
  //       let data = {
  //         id: element.id,
  //         value: element.name,
  //       };
  //       option.push(data);
  //     }
  //     if (isChange) {
  //       setListProvince(selectOption(isZero, option, "value"));
  //     } else {
  //       setListProvince(selectOption(currentProvince, option, "value"));
  //     }
  //     // setProvince(selectOption(currentProvince, option, "value"));
  //     setLoading(false);
  //   } else {
  //     setLoading(false);
  //   }
  // };
  // const getListDistrict = async (id, idprov, page, limit, filter, isChange) => {

  //   const currentDistrict = [...listDistrict];
  //   let districts = await doGets(
  //     `/district?page=${page}&limit=${limit}&filter=country_id eq ${id}, province_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
  //     }`,
  //     token
  //   );
  //   let option = [];
  //   let list = districts?.data?.payload?.data;
  //   if (list !== null && list.length !== undefined) {
  //     for (let i = 0; i < list.length; i++) {
  //       const element = list[i];
  //       let data = {
  //         id: element.id,
  //         value: element.name,
  //       };
  //       option.push(data);
  //     }
  //     if (isChange) {
  //       setListDistrict(selectOption(isZero, option, "value"));
  //     } else {
  //       setListDistrict(selectOption(currentDistrict, option, "value"));
  //     }
  //     setLoading(false);
  //   } else {
  //     setLoading(false);
  //   }
  // };

  // const getListSubDistrict = async (id, idprov, page, limit, filter, isChange) => {
  //   const currentSubdistrict = [...listSubDistrict];
  //   let districts = await doGets(
  //     `/sub_district?page=${page}&limit=${limit}&filter=country_id eq ${id}, district_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
  //     }`,
  //     token
  //   );
  //   let option = [];
  //   let list = districts?.data?.payload?.data;
  //   if (list !== null && list.length !== undefined) {
  //     for (let i = 0; i < list.length; i++) {
  //       const element = list[i];
  //       let data = {
  //         id: element.id,
  //         value: element.name,
  //       };
  //       option.push(data);
  //     }
  //     if (isChange) {
  //       setListSubDistrict(selectOption(isZero, option, "value"));
  //     } else {
  //       setListSubDistrict(selectOption(currentSubdistrict, option, "value"));
  //     }
  //     // setSubdistrict(selectOption(currentSubdistrict, option, "value"));
  //     setLoading(false);
  //   } else {
  //     setLoading(false);
  //   }
  // };

  // const getListUrbanVillage = async (id, idprov, page, limit, filter, isChange) => {
  //   const currentUrbanvillage = [...listUrbanVillage];
  //   let districts = await doGets(
  //     `/urban_village?page=${page}&limit=${limit}&filter=country_id eq ${id}, sub_district_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
  //     }`,
  //     token
  //   );
  //   let option = [];
  //   let list = districts?.data?.payload?.data;
  //   if (list !== null && list.length !== undefined) {
  //     for (let i = 0; i < list.length; i++) {
  //       const element = list[i];
  //       let data = {
  //         id: element.id,
  //         value: element.name,
  //       };
  //       option.push(data);
  //     }
  //     if (isChange) {
  //       setListUrbanVillage(selectOption(isZero, option, "value"));
  //     } else {
  //       setListUrbanVillage(selectOption(currentUrbanvillage, option, "value"));
  //     }
  //     // setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
  //     setLoading(false);
  //   } else {
  //     setLoading(false);
  //   }
  // };

  // const getListPostalCode = async (idUrbanVillage, page, limit, filter, isChange) => {
  //   const currentPostalCode = [...listPostalCode];
  //   let postal_code = await doGets(
  //     `/postal_code?page=${page}&limit=${limit}&filter=urban_village_id eq ${idUrbanVillage}${filter ? `, name lk ${filter}` : ""
  //     }`,
  //     token
  //   );
  //   let option = [];
  //   let list = postal_code?.data?.payload?.data;
  //   if (list !== null && list.length !== undefined) {
  //     for (let i = 0; i < list.length; i++) {
  //       const element = list[i];
  //       let data = {
  //         id: element.id,
  //         value: element.code,
  //       };
  //       option.push(data);
  //     }
  //     if (isChange) {
  //       setListPostalCode(selectOption(isZero, option, "value"));
  //     } else {
  //       setListPostalCode(selectOption(currentPostalCode, option, "value"));
  //     }
  //     // setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
  //     setLoading(false);
  //   } else {
  //     setLoading(false);
  //   }
  // };


  // const onScrollCountry = (event) => {
  //   let target = event.target;
  //   if (
  //     target.scrollHeight - Math.ceil(target.scrollTop) ===
  //     target.clientHeight ||
  //     (target.scrollHeight - Math.ceil(target.scrollTop) ===
  //       target.clientHeight + 1 &&
  //       !loading)
  //   ) {
  //     setLoading(true);

  //     setPageCountry(pageCountry + 1);
  //     target.scrollTo(0, target.scrollHeight);
  //     getListCountry(pageCountry, limitCountry);
  //     // setTimeout(() => {
  //     //   getListCountry(pageCountry,limitCountry)
  //     // }, 256);
  //   }
  // };

  // const onChangeCountry = (event) => {
  //   const { value } = event.target;
  //   const resetPage = 1;
  //   // clearTimeout(this.inputTimer);
  //   let filterSearch = value && `${value}`;
  //   // this.setState({
  //   //   searchValue: value,
  //   // });
  //   setSearchValue(value);
  //   let filter = [filterSearch];
  //   filter = filter.filter(
  //     (item) => item !== undefined && item !== null && item !== ""
  //   );
  //   filter = filter.length !== 0 ? filter.join(", ") : undefined;
  //   const resetFilter = filter;
  //   if (value.length >= 2) {
  //     setListCountry([]);
  //     setPageCountry(resetPage);
  //     // this.setState(
  //     setTimeout(() => {
  //       getListCountry(pageCountry, limitCountry, filter);
  //     }, 256);
  //   } else if (!value) {
  //     setLoading(true);
  //     setListCountry([]);
  //     setFilter(resetFilter);
  //     setPageCountry(resetPage);
  //     getListCountry(pageCountry, limitCountry, filter);
  //   }
  // };
  // const onScrollProvince = (event) => {
  //   let target = event.target;
  //   if (
  //     target.scrollHeight - Math.ceil(target.scrollTop) ===
  //     target.clientHeight ||
  //     (target.scrollHeight - Math.ceil(target.scrollTop) ===
  //       target.clientHeight + 1 &&
  //       !loading)
  //   ) {
  //     setLoading(true);
  //     console.log("sini g");
  //     setPageProvince(pageProvince + 1);
  //     target.scrollTo(0, target.scrollHeight);
  //     getListProvince(form?.country_id, pageProvince, limitProvince, "");
  //     // setTimeout(() => {
  //     //   getListProvince(pageProvince,limitProvince)
  //     // }, 256);
  //   }
  // };

  // const onChangeProvince = (event) => {
  //   const { value } = event.target;
  //   const resetPage = 1;
  //   // clearTimeout(this.inputTimer);
  //   let filterSearch = value && `${value}`;
  //   // this.setState({
  //   //   searchValue: value,
  //   // });
  //   setSearchValue(value);
  //   let filter = [filterSearch];
  //   filter = filter.filter(
  //     (item) => item !== undefined && item !== null && item !== ""
  //   );
  //   filter = filter.length !== 0 ? filter.join(", ") : undefined;
  //   const resetFilter = filter;
  //   if (value.length >= 2) {
  //     setListProvince([]);
  //     setPageProvince(resetPage);
  //     // this.setState(
  //     setTimeout(() => {
  //       getListProvince(form?.country_id, pageProvince, limitProvince, filter);
  //     }, 256);
  //   } else if (!value) {
  //     setLoading(true);
  //     setListProvince([]);
  //     setFilter(resetFilter);
  //     setPageProvince(resetPage);
  //     getListProvince(form?.country_id, pageProvince, limitProvince, filter);
  //   }
  // };

  // const onScrollDistrict = (event) => {
  //   let target = event.target;
  //   if (
  //     target.scrollHeight - Math.ceil(target.scrollTop) ===
  //     target.clientHeight ||
  //     (target.scrollHeight - Math.ceil(target.scrollTop) ===
  //       target.clientHeight + 1 &&
  //       !loading)
  //   ) {
  //     setLoading(true);
  //     console.log("sini g");
  //     setPageDistrict(pageDistrict + 1);
  //     target.scrollTo(0, target.scrollHeight);
  //     getListDistrict(
  //       form?.country_id,
  //       form?.province_id,
  //       pageDistrict,
  //       limitDistrict,
  //       ""
  //     );
  //     // setTimeout(() => {
  //     //   getListDistrict(pageDistrict,limitDistrict)
  //     // }, 256);
  //   }
  // };

  // console.log("searchv", searchValue);
  // const onChangeDistrict = (event) => {
  //   const { value } = event.target;
  //   const resetPage = 1;
  //   // clearTimeout(this.inputTimer);
  //   let filterSearch = value && `${value}`;
  //   // this.setState({
  //   //   searchValue: value,
  //   // });
  //   setSearchValue(value);
  //   let filter = [filterSearch];
  //   filter = filter.filter(
  //     (item) => item !== undefined && item !== null && item !== ""
  //   );
  //   filter = filter.length !== 0 ? filter.join(", ") : undefined;
  //   const resetFilter = filter;
  //   if (value.length >= 2) {
  //     setListDistrict([]);
  //     setPageDistrict(resetPage);
  //     // this.setState(
  //     setTimeout(() => {
  //       getListDistrict(
  //         form?.country_id,
  //         form?.province_id,
  //         pageDistrict,
  //         limitDistrict,
  //         filter
  //       );
  //     }, 256);
  //   } else if (!value) {
  //     setLoading(true);
  //     setListDistrict([]);
  //     setFilter(resetFilter);
  //     setPageDistrict(resetPage);
  //     getListDistrict(
  //       form?.country_id,
  //       form?.province_id,
  //       pageDistrict,
  //       limitDistrict,
  //       filter
  //     );
  //   }
  // };
  // const onScrollSubdistrict = (event) => {
  //   let target = event.target;
  //   if (
  //     target.scrollHeight - Math.ceil(target.scrollTop) ===
  //     target.clientHeight ||
  //     (target.scrollHeight - Math.ceil(target.scrollTop) ===
  //       target.clientHeight + 1 &&
  //       !loading)
  //   ) {
  //     setLoading(true);
  //     console.log("sini g");
  //     setPageSubdistrict(pageSubdistrict + 1);
  //     target.scrollTo(0, target.scrollHeight);
  //     getListSubDistrict(
  //       form?.country_id,
  //       form?.district_id,
  //       pageSubdistrict,
  //       limitSubdistrict,
  //       ""
  //     );
  //     // setTimeout(() => {
  //     //   getListSubdistrict(pageSubdistrict,limitSubdistrict)
  //     // }, 256);
  //   }
  // };

  // const onChangeSubdistrict = (event) => {
  //   const { value } = event.target;
  //   const resetPage = 1;
  //   // clearTimeout(this.inputTimer);
  //   let filterSearch = value && `${value}`;
  //   // this.setState({
  //   //   searchValue: value,
  //   // });
  //   setSearchValue(value);
  //   let filter = [filterSearch];
  //   filter = filter.filter(
  //     (item) => item !== undefined && item !== null && item !== ""
  //   );
  //   filter = filter.length !== 0 ? filter.join(", ") : undefined;
  //   const resetFilter = filter;
  //   if (value.length >= 2) {
  //     setListSubDistrict([]);
  //     setPageSubdistrict(resetPage);
  //     // this.setState(
  //     setTimeout(() => {
  //       getListSubDistrict(
  //         form?.country_id,
  //         form?.district_id,
  //         pageSubdistrict,
  //         limitSubdistrict,
  //         filter
  //       );
  //     }, 256);
  //   } else if (!value) {
  //     setLoading(true);
  //     setListSubDistrict([]);
  //     setFilter(resetFilter);
  //     setPageSubdistrict(resetPage);
  //     getListSubDistrict(
  //       form?.country_id,
  //       form?.district_id,
  //       pageSubdistrict,
  //       limitSubdistrict,
  //       filter
  //     );
  //   }
  // };
  // const onScrollUrbanvillage = (event) => {
  //   let target = event.target;
  //   if (
  //     target.scrollHeight - Math.ceil(target.scrollTop) ===
  //     target.clientHeight ||
  //     (target.scrollHeight - Math.ceil(target.scrollTop) ===
  //       target.clientHeight + 1 &&
  //       !loading)
  //   ) {
  //     setLoading(true);
  //     console.log("sini g");
  //     setPageUrbanvillage(pageUrbanvillage + 1);
  //     target.scrollTo(0, target.scrollHeight);
  //     getListUrbanVillage(
  //       form?.country_id,
  //       form?.sub_district_id,
  //       pageUrbanvillage,
  //       limitUrbanvillage,
  //       ""
  //     );
  //     // setTimeout(() => {
  //     //   getListUrbanvillage(pageUrbanvillage,limitUrbanvillage)
  //     // }, 256);
  //   }
  // };

  // const onScrollPostalCode = (event) => {
  //   let target = event.target;
  //   if (
  //     target.scrollHeight - Math.ceil(target.scrollTop) ===
  //     target.clientHeight ||
  //     (target.scrollHeight - Math.ceil(target.scrollTop) ===
  //       target.clientHeight + 1 &&
  //       !loading)
  //   ) {
  //     setLoading(true);
  //     setPagePostalCode(pagePostalCode + 1);
  //     target.scrollTo(0, target.scrollHeight);
  //     getListPostalCode(
  //       form?.urban_village_id,
  //       pagePostalCode,
  //       limitPostalCode,
  //       ""
  //     );
  //     // setTimeout(() => {
  //     //   getListUrbanvillage(pageUrbanvillage,limitUrbanvillage)
  //     // }, 256);
  //   }
  // };

  // const onChangeUrbanvillage = (event) => {
  //   const { value } = event.target;
  //   const resetPage = 1;
  //   // clearTimeout(this.inputTimer);
  //   let filterSearch = value && `${value}`;
  //   // this.setState({
  //   //   searchValue: value,
  //   // });
  //   setSearchValue(value);
  //   let filter = [filterSearch];
  //   filter = filter.filter(
  //     (item) => item !== undefined && item !== null && item !== ""
  //   );
  //   filter = filter.length !== 0 ? filter.join(", ") : undefined;
  //   const resetFilter = filter;
  //   if (value.length >= 2) {
  //     setListUrbanVillage([]);
  //     setPageUrbanvillage(resetPage);
  //     // this.setState(
  //     setTimeout(() => {
  //       getListUrbanVillage(
  //         form?.country_id,
  //         form?.sub_district_id,
  //         pageUrbanvillage,
  //         limitUrbanvillage,
  //         filter
  //       );
  //     }, 256);
  //   } else if (!value) {
  //     setLoading(true);
  //     setListUrbanVillage([]);
  //     setFilter(resetFilter);
  //     setPageUrbanvillage(resetPage);
  //     getListUrbanVillage(
  //       form?.country_id_id,
  //       form?.sub_district_id,
  //       pageUrbanvillage,
  //       limitUrbanvillage,
  //       filter
  //     );
  //   }
  // };

  // const onChangePostalCode = (event) => {
  //   const { value } = event.target;
  //   const resetPage = 1;
  //   // clearTimeout(this.inputTimer);
  //   let filterSearch = value && `${value}`;
  //   // this.setState({
  //   //   searchValue: value,
  //   // });
  //   setSearchValue(value);
  //   let filter = [filterSearch];
  //   filter = filter.filter(
  //     (item) => item !== undefined && item !== null && item !== ""
  //   );
  //   filter = filter.length !== 0 ? filter.join(", ") : undefined;
  //   const resetFilter = filter;
  //   if (value.length >= 2) {
  //     setListPostalCode([]);
  //     setPagePostalCode(resetPage);
  //     // this.setState(
  //     setTimeout(() => {
  //       getListPostalCode(
  //         form?.urban_village_id,
  //         pagePostalCode,
  //         limitPostalCode,
  //         filter
  //       );
  //     }, 256);
  //   } else if (!value) {
  //     setLoading(true);
  //     setListPostalCode([]);
  //     setFilter(resetFilter);
  //     setPagePostalCode(resetPage);
  //     getListPostalCode(
  //       form?.urban_village_id,
  //       pagePostalCode,
  //       limitPostalCode,
  //       filter
  //     );
  //   }
  // };

  return (
    <>
      <div className='font-roboto font-semibold text-[20px] mt-5'>
        {t("LOGIN_COMPLETION:TITLE_LAYOUT")}
      </div>
      <div className='font-roboto text-[16px] text-[#424242]'>
        {t("LOGIN_COMPLETION:SUB_TITLE_LAYOUT")}
      </div>

      <div className='font-roboto-medium text-[18px] font-medium mt-3'>
        {t("LOGIN_COMPLETION:PERSONAL_INFORMATION")}
      </div>

      <Row className='mt-3'>
        <Col span={10}>
          <div>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_USERNAME")}
            </p>
            <Input
              style={{ width: '100%' }}
              size='large'
              disabled
              value={form?.username}
            />
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_TITLE")}
            </p>
            <Input
              style={{ width: '100%' }}
              size='large'
              disabled
              value={form?.title}
            />
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_FIRST_NAME")}
            </p>
            <Input
              style={{ width: '100%' }}
              size='large'
              disabled
              value={form?.first_name}
            />
          </div>
        </Col>
        <Col span={4}> </Col>
        <Col span={10}>
          <div>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_GENDER")}
            </p>
            <Input
              style={{ width: '100%' }}
              size='large'
              disabled
              value={form?.gender}
            />
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_PHONE")}
            </p>
            <Input
              style={{ width: '100%' }}
              size='large'
              disabled
              value={form?.phone}
            />
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_LAST_NAME")}
            </p>
            <Input
              style={{ width: '100%' }}
              size='large'
              disabled
              value={form?.last_name}
            />
          </div>
        </Col>
      </Row>

      <hr className='border border-[#D9D9D9] my-10' />

      <div className='font-roboto font-semibold text-[20px]'>
        {t("LOGIN_COMPLETION:TITLE_GROLOG_ACC_INFORMATION")}
      </div>

      <Row>
        <Col span={10}>
          <div className='font-roboto-medium text-[18px] font-medium mt-3'>
            {t("LOGIN_COMPLETION:PERSONAL_INFORMATION")}
          </div>
        </Col>
        <Col span={4}></Col>
        <Col span={10}>
          <div className='font-roboto-medium text-[18px] font-medium mt-3'>
            {t("LOGIN_COMPLETION:ADDRESS_INFORMATION")}
          </div>
        </Col>
      </Row>

      <Row className='mt-3'>
        <Col span={10}>
          <div>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_EMAIL")}
            </p>
            <Input
              disabled
              style={{ width: '100%' }}
              size='large'
              value={form?.email}
              onChange={(evt) => { _onChange(evt, 'email') }}
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_EMAIL") })}
            />
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_NIK")} <i>(Optional)</i>
            </p>
            <Input
              style={{ width: '100%' }}
              size='large'
              status={error?.nik ? "error" : ""}
              value={form?.nik}
              onChange={(evt) => { _onChange(evt, 'nik') }}
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_NIK") })}
            />
            <div className="text-red-100">{error?.nik}</div>
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_BIRTH_PLACE")} <i>(Optional)</i>
            </p>
            <Input
              style={{ width: '100%' }}
              size='large'
              value={form?.birth_place}
              onChange={(evt) => { _onChange(evt, 'birth_place') }}
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_BIRTH_PLACE") })}
            />
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_BIRTH_DATE")} <i>(Optional)</i>
            </p>
            <DatePicker
              style={{ width: '100%' }}
              size='large'
              value={dayjs(form?.birth_day)}
              format="DD MMMM YYYY"
              onChange={(evt) => { _onChange(evt, 'birth_day') }}
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_BIRTH_DATE") })}
            />
          </div>
        </Col>
        <Col span={4}> </Col>
        <Col span={10}>
          <div>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_COUNTRY")}
            </p>
            {/* <SelectSearch onSelect={(value) => _onChangeSelect(value, 'country_id')} style={style} from={'USER'} data={listCountry} defaultValue={form?.country_id ? form?.country_id : null} /> */}
            <Select
                  className="w-[100%]"
                  status={error?.country_id ? "error" : ""}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  // onPopupScroll={(e) => onScrollCountry(e)}
                  value={form.country_id}
                  onChange={(value) => _onChangeSelect(value, "country_id")}
                  // options={country}
                  placeholder="Select depot country"
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangeCountry(value),
                      searchValue
                    )
                  }
                >
                  {!loading ? listCountry : [...listCountry]}
                </Select>
            <div className="text-red-100">{error?.country_id}</div>
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_PROVINCE")}
            </p>
            {/* <SelectSearch onSelect={(value) => _onChangeSelect(value, 'province_id')} style={style} from={'USER'} data={listProvince} defaultValue={form?.province_id ? form?.province_id : null} /> */}
            <Select
            disabled={!form?.country_id}
                  className="w-[100%]"
                  status={error?.province_id ? "error" : ""}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  onPopupScroll={(e) => onScrollProvince(e)}
                  value={form.province_id}
                  onChange={(value) => _onChangeSelect(value, "province_id")}
                  // options={Province}
                  placeholder="Select depot Province"
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangeProvince(value),
                      searchValue
                    )
                  }
                >
                  {!loading ? Province : [...Province]}
                </Select>
            <div className="text-red-100">{error?.province_id}</div>
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_DISTRICT")}
            </p>
            {/* <SelectSearch onSelect={(value) => _onChangeSelect(value, 'district_id')} style={style} from={'USER'} data={listDistrict} defaultValue={form?.district_id ? form?.district_id : null} /> */}
            <Select
            disabled={!form?.province_id}
                  className="w-[100%]"
                  status={error?.district_id ? "error" : ""}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  onPopupScroll={(e) => onScrollDistrict(e)}
                  value={form.district_id}
                  onChange={(value) => _onChangeSelect(value, "district_id")}
                  // options={District}
                  placeholder="Select depot District"
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangeDistrict(value),
                      searchValue
                    )
                  }
                >
                  {!loading ? District : [...District]}
                </Select>
            <div className="text-red-100">{error?.district_id}</div>
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_SUBDISTRICT")}
            </p>
            {/* <SelectSearch onSelect={(value) => _onChangeSelect(value, 'sub_district_id')} style={style} from={'USER'} data={listSubDistrict} defaultValue={form?.sub_district_id ? form?.sub_district_id : null} /> */}
            <Select
            disabled={!form?.district_id}
                  className="w-[100%]"
                  status={error?.sub_district_id ? "error" : ""}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  onPopupScroll={(e) => onScrollSubdistrict(e)}
                  value={form.sub_district_id}
                  onChange={(value) => _onChangeSelect(value, "sub_district_id")}
                  // options={SubDistrict}
                  placeholder="Select depot SubDistrict"
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangeSubdistrict(value),
                      searchValue
                    )
                  }
                >
                  {!loading ? SubDistrict : [...SubDistrict]}
                </Select>
            <div className="text-red-100">{error?.sub_district_id}</div>
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_URBAN_VILLAGE")}
            </p>
            {/* <SelectSearch onSelect={(value) => _onChangeSelect(value, 'urban_village_id')} style={style} from={'USER'} data={UrbanVillage} defaultValue={form?.urban_village_id ? form?.urban_village_id : null} /> */}
            <Select
            disabled={!form?.sub_district_id}
                  className="w-[100%]"
                  status={error?.urban_village_id ? "error" : ""}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  onPopupScroll={(e) => onScrollUrbanvillage(e)}
                  value={form.urban_village_id}
                  onChange={(value) => _onChangeSelect(value, "urban_village_id")}
                  // options={UrbanVillage}
                  placeholder="Select depot UrbanVillage"
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangeUrbanvillage(value),
                      searchValue
                    )
                  }
                >
                  {!loading ? UrbanVillage : [...UrbanVillage]}
                </Select>
            <div className="text-red-100">{error?.urban_village_id}</div>
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_ADDRESS")}
            </p>
            <TextArea
              style={{ width: '100%' }}
              size='large'
              status={error?.address ? "error" : ""}
              value={form?.address}
              onChange={(evt) => { _onChange(evt, 'address') }}
              placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_ADDRESS") })}
            />
            <div className="text-red-100">{error?.address}</div>
          </div>

          <div className='mt-3'>
            <Row>
              <Col span={9}>
                <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                  {t("LOGIN_COMPLETION:LBL_NEIGHBOURHOOD")} <i>(Optional)</i>
                </p>
              </Col>
              <Col span={2}></Col>
              <Col span={9}>
                <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
                  {t("LOGIN_COMPLETION:LBL_HAMLET")} <i>(Optional)</i>
                </p>
              </Col>
              <Col span={4}></Col>
            </Row>

            <Row>
              <Col span={9}>
                <Input
                  style={{ width: '100%' }}
                  size="large"
                  value={form?.neighbourhood}
                  maxLength={3}
                  status={error?.neighbourhood ? "error" : ""}
                  onChange={(evt) => { _onChange(evt, 'neighbourhood') }}
                  placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_NEIGHBOURHOOD") })}
                /><div className="text-red-100">{error?.neighbourhood}</div>
             
              </Col>
              
             <Col span={2}></Col>
              <Col span={9}>
                <Input
                  style={{ width: '100%' }}
                  size="large"
                  status={error?.hamlet ? "error" : ""}
                  value={form?.hamlet}
                  maxLength={3}
                  onChange={(evt) => { _onChange(evt, 'hamlet') }}
                  placeholder={t("COMMON:TYPE", { field: t("LOGIN_COMPLETION:LBL_HAMLET") })}
                />
                <div className="text-red-100">{error?.hamlet}</div>
              </Col>
              <Col span={4}></Col>
            </Row>
          </div>

          <div className='mt-3'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("LOGIN_COMPLETION:LBL_POSTAL_CODE")}
            </p>
            {/* <SelectSearch onSelect={(value) => _onChangeSelect(value, 'postal_code_id')} style={style} from={'USER'} data={PostalCode} defaultValue={form?.postal_code_id} /> */}
            <Select
            disabled={!form?.urban_village_id}
                  className="w-[100%]"
                  status={error?.postal_code_id ? "error" : ""}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  onPopupScroll={(e) => onScrollPostalCode(e)}
                  value={form.postal_code_id}
                  onChange={(value) => _onChangeSelect(value, "postal_code_id")}
                  // options={PostalCode}
                  placeholder="Select depot PostalCode"
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangePostalCode(value),
                      searchValue
                    )
                  }
                >
                  {!loading ? PostalCode : [...PostalCode]}
                </Select>
                <div className="text-red-100">{error?.postal_code_id}</div>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default UserProfile;